import React from 'react';
import loadericon from '../assets/icon/spinner.gif';

const SecondPageLoader = ({className= "background-general-950-opacity05"}) => {
    return (
        <div className={`loader_container ${className}`} id='second-overlay'>
            <div className='loader_div'>
                <img src={loadericon} alt='' width='80px' height='80px' />
            </div>
        </div>
    );
};

export default SecondPageLoader;
